// src/services/colaboradorService.js
// Serviço para operações de colaboradores

import api from './api';

export const fetchColaboradores = async ({ 
  page = 1, 
  limit = 10, 
  nome = '', 
  email = '', 
  cargo = '', 
  cpf = '', 
  bairro = '', 
  cidade = '', 
  estado = '', 
  escolaridade = '', 
  nomeIgrejaCongrega = '',
  status = '',
  funcao = '',
  extensoes = []
} = {}) => {
  try {
    const params = new URLSearchParams();
    
    if (page) params.append('page', page.toString());
    if (limit) params.append('limit', limit.toString());
    if (nome) params.append('nome', nome);
    if (email) params.append('email', email);
    if (cargo) params.append('cargo', cargo);
    if (cpf) params.append('cpf', cpf);
    if (bairro) params.append('bairro', bairro);
    if (cidade) params.append('cidade', cidade);
    if (estado) params.append('estado', estado);
    if (escolaridade) params.append('escolaridade', escolaridade);
    if (nomeIgrejaCongrega) params.append('nomeIgrejaCongrega', nomeIgrejaCongrega);
    if (status) params.append('status', status);
    if (funcao) params.append('funcao', funcao);
    if (extensoes && extensoes.length > 0) {
      params.append('extensoes', JSON.stringify(extensoes));
    }

    const response = await api.get(`/colaboradores?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar colaboradores:', error);
    throw error;
  }
};

export const createColaborador = async (colaborador) => {
  try {
    const response = await api.post('/colaboradores', colaborador);
    return response.data;
  } catch (error) {
    console.error('Erro ao criar colaborador:', error);
    throw error;
  }
};

export const updateColaborador = async (id, colaborador) => {
  try {
    const response = await api.put(`/colaboradores/${id}`, colaborador);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar colaborador:', error);
    throw error;
  }
};

export const deleteColaborador = async (id) => {
  try {
    const response = await api.delete(`/colaboradores/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao deletar colaborador:', error);
    throw error;
  }
};

export const getColaboradorById = async (id) => {
  try {
    const response = await api.get(`/colaboradores/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar colaborador:', error);
    throw error;
  }
};
